import Vue from "vue";
import "./components";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./http";
import "@fortawesome/fontawesome-free/css/all.css";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.config.productionTip = true;

Vue.use(VueLodash, { lodash: lodash });

Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
